
import numbro from 'numbro'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import NgtorchRunChip from '@/components/NgtorchRunChip.vue'
export default {
  name: 'automaticModels',
  components: {
    NgtorchRunChip
  },
  data () {
    return {
      // Wizard state
      wizardDialog: false,
      wizardStep: 1,
      wizardModelId: null,
      wizardModelName: '',
      wizardUploading: false,
      wizardGenerating: false,
      wizardServerError: '',
      wizardMonthly: false,
      // File
      currentFile: null,
      // Validation errors dialog
      validationErrorsDialog: false,
      selectedModelErrors: [],
      expandedErrorGroups: {},
      // Priors
      userPriorsMarketingMin: 0,
      userPriorsMarketingMax: 100,
      channelRoasEntries: {},
      enabledChannelRoas: {},
      fastDecayChannels: [],
      constraintSelection: null,
      savingUserPriors: false,
      clientNameExists: false,
      checkingClientName: false,
      // Delete
      deleteDialog: false,
      deleteItem: null,
      deletingModelId: null,
      priorsNeedInit: true,
      channelDisplayNames: {}
    }
  },
  methods: {
    ...mapActions('storage', [
      'uploadFile',
      'getFileDownloadUrl'
    ]),
    ...mapActions('autoModels', [
      'createAutoModelRequest',
      'uploadAutoModelFile',
      'loadAutoModelRequests',
      'deleteAutoModelRequest',
      'queueAutoModelGeneration',
      'checkClientNameExists'
    ]),
    ...mapActions('clients', [
      'loadNewClient'
    ]),
    // --- Wizard lifecycle ---
    openWizard: function () {
      this.wizardModelName = ''
      this.wizardModelId = null
      this.wizardStep = 1
      this.wizardUploading = false
      this.wizardGenerating = false
      this.wizardServerError = ''
      this.wizardMonthly = false
      this.currentFile = null
      this.userPriorsMarketingMin = 0
      this.userPriorsMarketingMax = 100
      this.channelRoasEntries = {}
      this.enabledChannelRoas = {}
      this.fastDecayChannels = []
      this.constraintSelection = null
      this.clientNameExists = false
      this.checkingClientName = false
      this.priorsNeedInit = true
      this.channelDisplayNames = {}
      this.wizardDialog = true
    },
    closeWizard: function () {
      var self = this
      if (self.wizardModelId) {
        self.deleteAutoModelRequest({ docId: self.wizardModelId }).catch(function () {})
      }
      self.wizardDialog = false
      self.wizardModelId = null
      self.currentFile = null
    },
    // --- Wizard navigation ---
    wizardNext: function () {
      if (this.wizardStep === 1 && this.priorsNeedInit) {
        this.initPriorsFromModel()
        this.priorsNeedInit = false
      }
      this.wizardStep += 1
    },
    wizardPrevious: function () {
      this.wizardStep -= 1
    },
    // --- File upload ---
    selectWizardFile: function () {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    handleWizardFileSelect: function () {
      var file = this.$refs.file.files[0]
      if (!file) return
      var allowedTypes = { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true }
      if (!allowedTypes[file.type]) {
        alert(this.$t('views.automaticModels.unsupportedFileType'))
        return
      }
      this.currentFile = file
      var self = this
      if (!self.wizardModelId) {
        self.createAutoModelRequest({
          name: '',
          uploadedBy: self.authUser.firstName + ' ' + self.authUser.lastName,
          uploadedById: self.authUser.uid,
          monthly: self.wizardMonthly
        }).then(function (result) {
          self.wizardModelId = result.id
          self.triggerWizardUpload(file)
        }).catch(function () {
          alert(self.$t('views.automaticModels.errorUploadingFile'))
          self.currentFile = null
        })
      } else {
        self.triggerWizardUpload(file)
      }
    },
    triggerWizardUpload: function (file) {
      var self = this
      var storagePath = '/autoModelData/staging/' + self.authUser.uid + '/' + self.wizardModelId + '/data.xlsx'
      self.wizardUploading = true
      self.priorsNeedInit = true
      self.uploadFile({
        file: file,
        path: storagePath,
        customMetadata: {
          uploadedBy: self.authUser.email
        }
      }).then(function () {
        return self.uploadAutoModelFile({
          docId: self.wizardModelId,
          userId: self.authUser.uid,
          originalFileName: file.name,
          monthly: self.wizardMonthly
        })
      }).catch(function () {
        self.currentFile = null
      }).finally(function () {
        self.wizardUploading = false
      })
    },
    cancelUpload: function () {
      if (this.uploadFileProgress && this.uploadFileProgress.task) {
        this.uploadFileProgress.task.cancel()
      }
      this.wizardUploading = false
      this.currentFile = null
    },
    // --- Priors initialization ---
    initPriorsFromModel: function () {
      var model = this.wizardModel
      if (!model) return
      var channels = model.mediaChannels || []
      var entries = {}
      var enabled = {}
      channels.forEach(function (ch) {
        entries[ch] = { min: 0.8, max: 1.2 }
        enabled[ch] = false
      })
      this.channelRoasEntries = entries
      this.enabledChannelRoas = enabled
      this.fastDecayChannels = []
      this.constraintSelection = null
      this.userPriorsMarketingMin = 0
      this.userPriorsMarketingMax = 100
    },
    // --- Generate ---
    generateFromWizard: function () {
      var self = this
      self.wizardGenerating = true
      self.wizardServerError = ''
      var trimmedName = self.wizardModelName.trim()
      self.checkClientNameExists(trimmedName).then(function (exists) {
        if (exists) {
          self.wizardServerError = self.$t('views.automaticModels.generateNameExistsInClients')
          self.wizardGenerating = false
          return
        }
        // Build priors payload
        var attrInfo = {}
        if (self.constraintSelection === 'attribution') {
          attrInfo.constraint_selection = 'mkt_incremental'
          attrInfo.target_mkt_incremental = {
            lower: self.userPriorsMarketingMin / 100,
            upper: self.userPriorsMarketingMax / 100
          }
          attrInfo.target_mkt_roas = {}
        } else if (self.constraintSelection === 'targetRoas') {
          attrInfo.constraint_selection = 'mkt_roas'
          attrInfo.target_mkt_incremental = {}
          var roasPayload = {}
          self.channelRoasChannelList.forEach(function (ch) {
            if (!self.enabledChannelRoas[ch]) return
            var entry = self.channelRoasEntries[ch]
            roasPayload[ch] = {
              lower: Number(entry.min),
              upper: Number(entry.max)
            }
          })
          attrInfo.target_mkt_roas = roasPayload
        }
        var priors = {
          attribution_information: attrInfo,
          fast_decay_media: self.fastDecayChannels
        }
        // Build pretty names from channel display names
        var prettyNamesMedia = {}
        Object.keys(self.channelDisplayNames).forEach(function (ch) {
          prettyNamesMedia[ch] = self.channelDisplayNames[ch]
        })
        // Save priors, model name, and mark as queued
        return self.queueAutoModelGeneration({
          docId: self.wizardModelId,
          name: trimmedName,
          user_priors: priors,
          pretty_names_media: prettyNamesMedia
        }).then(function () {
          // Success - clear wizardModelId so closeWizard won't delete the request
          self.wizardModelId = null
          self.wizardDialog = false
          self.currentFile = null
        })
      }).catch(function () {
        self.wizardServerError = self.$t('views.automaticModels.errorGeneratingModel')
      }).finally(function () {
        self.wizardGenerating = false
      })
    },
    channelMinError: function (channel) {
      if (!this.enabledChannelRoas[channel]) return []
      var entry = this.channelRoasEntries[channel]
      if (!entry) return []
      var min = entry.min
      if (min !== '' && min !== null && !isNaN(min) && Number(min) <= 0) {
        return [this.$t('views.automaticModels.priorsValueMustBePositive')]
      }
      return []
    },
    channelMaxError: function (channel) {
      if (!this.enabledChannelRoas[channel]) return []
      var entry = this.channelRoasEntries[channel]
      if (!entry) return []
      var max = entry.max
      if (max !== '' && max !== null && !isNaN(max) && Number(max) <= 0) {
        return [this.$t('views.automaticModels.priorsValueMustBePositive')]
      }
      if (max !== '' && max !== null && !isNaN(max) && Number(max) > 10) {
        return [this.$t('views.automaticModels.priorsChannelMaxLimit')]
      }
      var min = entry.min
      if (min !== '' && min !== null && !isNaN(min) && max !== '' && max !== null && !isNaN(max) && Number(max) <= Number(min)) {
        return [this.$t('views.automaticModels.priorsMaxBelowMin')]
      }
      return []
    },
    // --- Validation errors ---
    showWizardErrors: function () {
      var model = this.wizardModel
      if (model && model.validation && model.validation.errors) {
        this.selectedModelErrors = model.validation.errors
      } else {
        this.selectedModelErrors = []
      }
      this.expandedErrorGroups = {}
      this.validationErrorsDialog = true
    },
    toggleErrorGroup: function (key) {
      this.$set(this.expandedErrorGroups, key, !this.expandedErrorGroups[key])
    },
    sheetErrorCount: function (items) {
      var count = 0
      items.forEach(function (item) {
        if (item.type === 'group') {
          count += item.errors.length
        } else {
          count += 1
        }
      })
      return count
    },
    sheetDisplayName: function (sheet) {
      if (sheet === 'general') {
        return this.$t('views.automaticModels.sheetGeneral')
      }
      return sheet
    },
    sheetIcon: function (sheet) {
      var icons = {
        general: 'mdi-alert-circle-outline',
        '1. Own KPI': 'mdi-chart-line',
        '2. Own Controllable Media': 'mdi-bullhorn-outline',
        '3. Special Dates & Outliers': 'mdi-calendar-star'
      }
      return icons[sheet] || 'mdi-file-document-outline'
    },
    stripRowPrefix: function (description) {
      return description.replace(/^Row \d+:\s*/, '')
    },
    normalizeErrorDescription: function (description) {
      return description.replace(/'[^']*'/g, '').replace(/\s+/g, ' ').trim()
    },
    extractQuotedValues: function (description) {
      var matches = description.match(/'[^']*'/g)
      if (!matches) return ''
      return matches.map(function (m) { return m.slice(1, -1) }).join(', ')
    },
    downloadErrorsCsv: function () {
      this.downloadErrorsCsvFromList(this.selectedModelErrors)
    },
    downloadWizardErrorsCsv: function () {
      var model = this.wizardModel
      var errors = (model && model.validation && model.validation.errors) ? model.validation.errors : []
      this.downloadErrorsCsvFromList(errors)
    },
    downloadErrorsCsvFromList: function (errors) {
      var rows = [['Sheet', 'Row', 'Description']]
      var self = this
      errors.forEach(function (err) {
        var sheet = err.sheet || 'General'
        var row = err.row || ''
        var desc = err.row ? self.stripRowPrefix(err.description) : err.description
        var escapeCsv = function (val) {
          var str = String(val)
          return '"' + str.replace(/"/g, '""') + '"'
        }
        rows.push([escapeCsv(sheet), escapeCsv(row), escapeCsv(desc)])
      })
      var csvContent = rows.map(function (r) { return r.join(',') }).join('\n')
      var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      var url = URL.createObjectURL(blob)
      var link = document.createElement('a')
      link.href = url
      link.download = 'validation-errors.csv'
      link.click()
      URL.revokeObjectURL(url)
    },
    printUserPriors: function (item) {
      console.log('user_priors for ' + (item.name || item.id) + ':', JSON.stringify(item.user_priors, null, 2))
    },
    downloadDataTemplate: function (item) {
      if (item.storagePath) {
        this.downloadFile(item.storagePath)
      }
    },
    downloadAssemblerPkl: function (item) {
      var path = 'autoModelData/staging/' + item.uploaded_by_id + '/' + item.id + '/assembler.pkl'
      this.downloadFile(path)
    },
    printConfigMap: function (item) {
      console.log('config for ' + (item.name || item.id) + ':', JSON.stringify(item.config, null, 2))
    },
    // --- Utilities ---
    fileSizeToString: function (size) {
      return numbro(size).format({
        output: 'byte',
        base: 'binary',
        mantissa: 1
      })
    },
    formatDateRelative: function (timestamp) {
      if (!timestamp) return ''
      var now = Date.now()
      var diff = Math.max(0, Math.floor((now - timestamp) / 1000))
      if (diff < 60) return 'now'
      var minutes = Math.floor(diff / 60)
      if (minutes < 60) return minutes + 'm'
      var hours = Math.floor(minutes / 60)
      if (hours < 24) return hours + 'h'
      var days = Math.floor(hours / 24)
      if (days < 30) return days + 'd'
      var months = Math.floor(days / 30)
      if (months < 12) return months + 'mo'
      var years = Math.floor(months / 12)
      return years + 'y'
    },
    formatDateCreated: function (timestamp) {
      if (!timestamp) return ''
      var d = new Date(timestamp)
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return months[d.getMonth()] + ' ' + d.getDate() + ' ' + d.getFullYear() + ' ' + d.toTimeString().slice(0, 5)
    },
    downloadFile: function (filePath) {
      var self = this
      this.getFileDownloadUrl({
        path: filePath
      }).then(function (url) {
        self.$refs.fileDownload.href = url
        self.$refs.fileDownload.click()
      })
    },
    // --- Delete model ---
    confirmDeleteModel: function (item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    triggerDeleteAutoModel: function () {
      var self = this
      var item = self.deleteItem
      if (!item) return
      self.deleteDialog = false
      self.deletingModelId = item.id
      self.deleteAutoModelRequest({ docId: item.id }).catch(function () {
        // Silently handle errors - the snapshot listener will update the UI
      }).finally(function () {
        self.deletingModelId = null
        self.deleteItem = null
      })
    },
    statusLabel: function (status) {
      var labels = {
        pending: this.$t('views.automaticModels.statusPending'),
        uploaded: this.$t('views.automaticModels.statusUploaded'),
        queued: this.$t('views.automaticModels.statusGenerating'),
        spawning: this.$t('views.automaticModels.statusGenerating'),
        generating: this.$t('views.automaticModels.statusGenerating'),
        generated: this.$t('views.automaticModels.statusGenerated'),
        error: this.$t('views.automaticModels.statusError')
      }
      return labels[status] || status
    },
    statusColor: function (status) {
      var colors = {
        pending: 'grey lighten-1',
        uploaded: 'grey lighten-1',
        queued: 'primary',
        spawning: 'primary',
        generating: 'primary',
        generated: 'success',
        error: 'error'
      }
      return colors[status] || 'grey lighten-1'
    },
    statusTextColor: function (status) {
      if (status === 'pending' || status === 'uploaded') return 'black'
      if (status === 'generating') return 'white'
      return 'white'
    },
    parseReport: function (item) {
      if (!item.report) return null
      if (typeof item.report === 'string') {
        try { return JSON.parse(item.report) } catch (e) { return null }
      }
      return item.report
    },
    hasHighMape: function (item) {
      var report = this.parseReport(item)
      if (!report || !report.v2 || !report.v2.model_quality) return false
      var mape = report.v2.model_quality.MAPE
      return typeof mape === 'number' && mape >= 20
    },
    getItemMape: function (item) {
      var report = this.parseReport(item)
      if (!report || !report.v2 || !report.v2.model_quality) return null
      return report.v2.model_quality.MAPE
    },
    getItemConstraintDetails: function (item) {
      if (!item || !item.user_priors || !item.user_priors.attribution_information) return null
      var info = item.user_priors.attribution_information
      var selection = info.constraint_selection
      if (selection === 'mkt_incremental') {
        var target = info.target_mkt_incremental
        if (!target) return null
        var min = Math.round(target.lower * 100)
        var max = Math.round(target.upper * 100)
        return {
          label: this.$t('views.automaticModels.detailsAttribution'),
          color: 'primary',
          title: this.$t('views.automaticModels.detailsAttribution'),
          lines: [min + '% – ' + max + '%']
        }
      }
      if (selection === 'mkt_roas') {
        var channels = info.target_mkt_roas
        if (!channels || typeof channels !== 'object') return null
        var keys = Object.keys(channels)
        if (keys.length === 0) return null
        var prettyMedia = item.pretty_names_media
        var lines = keys.map(function (name) {
          var ch = channels[name]
          var displayName = (prettyMedia && prettyMedia[name]) ? prettyMedia[name] : name
          return { name: displayName, range: ch.lower + ' – ' + ch.upper }
        })
        return {
          label: this.$t('views.automaticModels.detailsRoas'),
          color: 'teal',
          title: this.$t('views.automaticModels.detailsRoasChannels'),
          lines: lines
        }
      }
      return null
    },
    getItemFastDecayDetails: function (item) {
      if (!item || !item.user_priors || !item.user_priors.fast_decay_media) return null
      var channels = item.user_priors.fast_decay_media
      if (!Array.isArray(channels) || channels.length === 0) return null
      var prettyMedia = item.pretty_names_media
      var displayChannels = channels.map(function (ch) {
        return (prettyMedia && prettyMedia[ch]) ? prettyMedia[ch] : ch
      })
      return { channels: displayChannels }
    },
    buildGroupedErrorList: function (errors) {
      var self = this
      if (!errors || errors.length === 0) return []
      var sheetOrder = ['general', '1. Own KPI', '2. Own Controllable Media', '3. Special Dates & Outliers']
      var grouped = _.groupBy(errors, function (err) {
        return err.sheet || 'general'
      })
      var result = []

      function buildItems (sheetErrors) {
        var standalone = []
        var rowErrors = []
        sheetErrors.forEach(function (err) {
          if (err.row) {
            rowErrors.push(err)
          } else {
            standalone.push(err)
          }
        })
        var items = standalone.map(function (err) {
          return { type: 'standalone', error: err }
        })
        var byDesc = _.groupBy(rowErrors, function (err) {
          return self.normalizeErrorDescription(self.stripRowPrefix(err.description))
        })
        Object.keys(byDesc).forEach(function (normalizedDesc) {
          var group = byDesc[normalizedDesc]
          if (group.length === 1) {
            items.push({ type: 'single', error: group[0] })
          } else {
            items.push({
              type: 'group',
              description: normalizedDesc,
              errors: group,
              rows: group.map(function (e) { return e.row })
            })
          }
        })
        return items
      }

      sheetOrder.forEach(function (sheet) {
        if (grouped[sheet] && grouped[sheet].length > 0) {
          result.push({ sheet: sheet, items: buildItems(grouped[sheet]) })
        }
      })
      Object.keys(grouped).forEach(function (sheet) {
        if (sheetOrder.indexOf(sheet) === -1) {
          result.push({ sheet: sheet, items: buildItems(grouped[sheet]) })
        }
      })
      return result
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    ...mapGetters('storage', [
      'uploadFileProgress'
    ]),
    ...mapGetters('autoModels', [
      'autoModelRequests'
    ]),
    ...mapGetters('clients', [
      'clients'
    ]),
    // --- Wizard computed ---
    wizardModel: function () {
      var self = this
      if (!self.wizardModelId) return null
      var found = self.autoModelRequests.find(function (m) {
        return m.id === self.wizardModelId
      })
      return found || null
    },
    wizardValidation: function () {
      var model = this.wizardModel
      return model && model.validation ? model.validation : null
    },
    wizardCanProceedFromUpload: function () {
      if (!this.wizardValidation || this.wizardValidation.status !== 'valid') return false
      var self = this
      var channels = (this.wizardModel && this.wizardModel.mediaChannels) ? this.wizardModel.mediaChannels : []
      var hasEmptyDisplayName = channels.some(function (ch) {
        var name = self.channelDisplayNames[ch]
        return !name || !name.trim()
      })
      if (hasEmptyDisplayName) return false
      return true
    },
    wizardModelNameErrors: function () {
      var trimmed = this.wizardModelName.trim().toLowerCase()
      if (!trimmed) return []
      var errors = []
      var self = this
      var usedInRequests = this.autoModelRequests.some(function (m) {
        return m.id !== self.wizardModelId && m.name && m.name.toLowerCase() === trimmed
      })
      if (usedInRequests) {
        errors.push(this.$t('views.automaticModels.generateNameAlreadyUsed'))
      }
      if (this.clientNameExists) {
        errors.push(this.$t('views.automaticModels.generateNameExistsInClients'))
      }
      return errors
    },
    // --- Priors computed ---
    marketingMinError: function () {
      var min = this.userPriorsMarketingMin
      if (min !== '' && min !== null && !isNaN(min)) {
        if (Number(min) < 0) return [this.$t('views.automaticModels.priorsValueOutOfRange')]
        if (Number(min) > 100) return [this.$t('views.automaticModels.priorsValueOutOfRange')]
      }
      return []
    },
    marketingMaxError: function () {
      var max = this.userPriorsMarketingMax
      if (max !== '' && max !== null && !isNaN(max)) {
        if (Number(max) <= 0) return [this.$t('views.automaticModels.priorsValueMustBePositive')]
        if (Number(max) > 100) return [this.$t('views.automaticModels.priorsValueOutOfRange')]
      }
      var min = this.userPriorsMarketingMin
      if (min !== '' && min !== null && !isNaN(min) && max !== '' && max !== null && !isNaN(max) && Number(max) <= Number(min)) {
        return [this.$t('views.automaticModels.priorsMaxBelowMin')]
      }
      return []
    },
    channelRoasChannelList: function () {
      return Object.keys(this.channelRoasEntries).sort()
    },
    fastDecayChannelItems: function () {
      var self = this
      return this.channelRoasChannelList.map(function (ch) {
        return { value: ch, label: self.channelDisplayNames[ch] || ch }
      })
    },
    userPriorsValid: function () {
      if (!this.constraintSelection) return false
      if (this.constraintSelection === 'attribution') {
        var min = this.userPriorsMarketingMin
        var max = this.userPriorsMarketingMax
        if (min === '' || min === null || max === '' || max === null) return false
        if (isNaN(min) || isNaN(max)) return false
        if (Number(min) < 0 || Number(max) > 100) return false
        if (Number(max) <= 0) return false
        if (Number(min) >= Number(max)) return false
        return true
      }
      if (this.constraintSelection === 'targetRoas') {
        var self = this
        var hasEnabled = false
        var channelInvalid = false
        this.channelRoasChannelList.forEach(function (ch) {
          if (!self.enabledChannelRoas[ch]) return
          hasEnabled = true
          var entry = self.channelRoasEntries[ch]
          if (entry.min === '' || entry.min === null || entry.max === '' || entry.max === null) channelInvalid = true
          if (isNaN(entry.min) || isNaN(entry.max)) channelInvalid = true
          if (Number(entry.min) < 0) channelInvalid = true
          if (Number(entry.max) <= 0) channelInvalid = true
          if (Number(entry.max) > 10) channelInvalid = true
          if (Number(entry.max) <= Number(entry.min)) channelInvalid = true
        })
        if (!hasEnabled) return false
        if (channelInvalid) return false
        return true
      }
      return false
    },
    // --- Auto model requests ---
    sortedAutoModelRequests: function () {
      return this.autoModelRequests.filter(function (r) {
        return r.status === 'queued' || r.status === 'spawning' || r.status === 'generating' || r.status === 'generated' || r.status === 'error'
      }).slice().sort(function (a, b) {
        var dateA = a.dateCreated || 0
        var dateB = b.dateCreated || 0
        return dateB - dateA
      })
    },
    allRequestHeaders: function () {
      var headers = [
        { text: this.$t('views.automaticModels.headerModelName'), value: 'name' },
        { text: this.$t('views.automaticModels.headerDetails'), value: 'details', sortable: false, width: '185px' },
        { text: this.$t('views.automaticModels.headerDateCreated'), value: 'dateCreated' }
      ]
      if (this.authUser.isAdmin || this.authUser.isScientist || this.authUser.isManager) {
        headers.push({ text: this.$t('views.automaticModels.headerCreatedBy'), value: 'uploadedBy' })
      }
      headers.push({ text: this.$t('views.automaticModels.headerStatus'), value: 'status', sortable: false })
      headers.push({ text: '', value: 'actions', sortable: false, width: '100px' })
      return headers
    },
    // --- Error grouping ---
    wizardGroupedErrors: function () {
      var model = this.wizardModel
      var errors = (model && model.validation && model.validation.errors) ? model.validation.errors : []
      return this.buildGroupedErrorList(errors)
    },
    groupedErrors: function () {
      return this.buildGroupedErrorList(this.selectedModelErrors)
    }
  },
  watch: {
    'wizardModel.mediaChannels': function (newChannels) {
      if (!newChannels || !newChannels.length) return
      var self = this
      var needsInit = newChannels.some(function (ch) {
        return self.channelDisplayNames[ch] === undefined
      })
      if (needsInit) {
        var names = {}
        newChannels.forEach(function (ch) {
          names[ch] = (self.channelDisplayNames[ch] !== undefined) ? self.channelDisplayNames[ch] : ch
        })
        self.channelDisplayNames = names
      }
    },
    wizardStep: function (step) {
      var self = this
      self.$nextTick(function () {
        if (step === 2 && self.$refs.marketingMinField) {
          self.$refs.marketingMinField.focus()
        } else if (step === 4 && self.$refs.modelNameField) {
          self.$refs.modelNameField.focus()
        }
      })
    },
    autoModelRequests: function (requests) {
      var self = this
      if (!requests) return
      requests.forEach(function (request) {
        if (request.clientId && request.status === 'generated') {
          var alreadyLoaded = self.clients.some(function (c) { return c.id === request.clientId })
          if (!alreadyLoaded) {
            self.loadNewClient({ id: request.clientId })
          }
        }
      })
    },
    wizardModelName: function (newVal) {
      var self = this
      if (!newVal || !newVal.trim()) {
        self.clientNameExists = false
        self.checkingClientName = false
        if (self.debouncedCheckClientName) {
          self.debouncedCheckClientName.cancel()
        }
        return
      }
      self.checkingClientName = true
      self.debouncedCheckClientName(newVal.trim())
    }
  },
  created: function () {
    this.loadAutoModelRequests({
      userId: this.authUser.uid,
      loadAll: this.authUser.isAdmin || this.authUser.isScientist || this.authUser.isManager
    })
    var self = this
    this.debouncedCheckClientName = _.debounce(function (name) {
      self.checkClientNameExists(name).then(function (exists) {
        // Stale-result protection: only apply if name still matches
        if (self.wizardModelName.trim() === name) {
          self.clientNameExists = exists
          self.checkingClientName = false
        }
      }).catch(function () {
        if (self.wizardModelName.trim() === name) {
          self.checkingClientName = false
        }
      })
    }, 400)
  },
  beforeDestroy: function () {
    if (this.debouncedCheckClientName) {
      this.debouncedCheckClientName.cancel()
    }
  }
}
